module.exports = __webpack_public_path__ + "static/media/Shinx_gaussian2.8a678f26.png";